module.exports = __webpack_public_path__ + "static/media/purchase_orderF.78957dbb.svg";